var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('enum-picker',{attrs:{"rules":_vm.rules,"enum":_vm.onemDerecesi,"labels":_vm.onemDerecesiLabel,"label":_vm.label ? _vm.label : 'Önem Derecesi'},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }